import React, { Component } from 'react';
import { connect } from 'react-redux';
import Multiselect from 'multiselect-react-dropdown';
import Header from './header'
import Menu from './menu'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
let oid = OPERATOR_ID.toLowerCase()

class WACCasino extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            allGames: [],
            showPopup: false,
            operator: OPERATOR_ID,
            gameType: "new",
            gameCategory: "All",
            openGame: false,
            wACSrc: '',
            link: "",
            loader: false,
            partner: [],
            categories: [],
            selectedPartner: "",
            selectedCategory: "",
            searchGame: ""
        };
    }
    componentDidMount() {
        const operator = this.state.operator
        let token = JSON.parse(localStorage.getItem('userAuthDetail'))
        let rl = token?.role
        token = !!token ? token.token : null
        if (!!operator && !!token && rl !== 'DemoClient') {
            window.localStorage.setItem("operator", operator);
            window.localStorage.setItem("token", token);
            GamesService.getWACCasino().then((res) => {
                if (!!res.data && res.data.length > 0) {
                    let games = res.data.sort((a, b) => (a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0))
                    const partner = this.createFilterArrayList(games, "partner")
                    const category = this.createFilterArrayList(games, "category");
                    this.setState({ games: games, partner: partner, categories: category })
                }
                this.setState({ loader: false })
            })

        }
    }

    getIndividualGame = async (gameId) => {
        this.setState({ isLoading: true });
        const gameRes = await GamesService.getIndividualGame(gameId);
        const gameData = gameRes.data;
        if (!gameData && !gameRes.isSuccess && !!gameRes?.exception?.message) {
            this.props.MySwal.fire({
                title: 'Error',
                text: `${gameRes?.exception?.code} ${gameRes?.exception?.message}`,
                icon: 'error',
                confirmButtonText: 'OK',
            })
            this.setState({ loader: false });
            // this.setState({ showPopup: true, popupMessage: gameRes.message });
        }
        if (!!gameData && !!gameData.url) {
            this.setState({ openGame: true, link: gameData.url })
        }
    }

    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    createFilterArrayList(gmArry, attr) {
        let arrysngl = [];
        let arry = [];

        for (const itm of gmArry) {

            if (arrysngl.includes(itm[attr]) === false) {
                arrysngl.push(itm[attr]);
                arry.push({ name: itm[attr], id: itm[attr] })
            }
        }
        return arry
    }

    getSelectedValuesArray(arry, attr) {
        let selectedarrayvals = []
        for (const itma of arry) {
            selectedarrayvals.push(itma[attr].toLowerCase());
        }
        return selectedarrayvals
    }

    handleSelectPartner(data) {
        this.setState({ selectedPartner: data, selectedCategory: "" }, () => {
            const games = this.filterGameList(this.state.games);
            const category = this.createFilterArrayList(games, "category");
            this.setState({ categories: category })
        })
    }
    handleSelectCategory(data) {
        this.setState({ selectedCategory: data })
    }

    filterGameList() {
        let returnGames = this.state.games;
        if (!!this.state.selectedPartner && this.state.selectedPartner.length > 0) {
            let selectedpartnerarray = this.getSelectedValuesArray(this.state.selectedPartner, "id")
            returnGames = returnGames.filter((itm) => {
                return selectedpartnerarray.includes(itm.partner.toLowerCase())//itm.provider === this.state.selectedProvider
            })
        }
        if (!!this.state.selectedCategory && this.state.selectedCategory.length > 0) {
            let selectedcategoryarray = this.getSelectedValuesArray(this.state.selectedCategory, "id")
            returnGames = returnGames.filter((itm) => {
                return selectedcategoryarray.includes(itm.category.toLowerCase())//itm.provider === this.state.selectedProvider
            })
        }
        if (!!this.state.searchGame) {
            returnGames = returnGames.filter((itm) => {
                return itm.gameName.toLowerCase().includes(this.state.searchGame.toLowerCase())
            })
        }
        return returnGames
    }

    render() {
        const gameList = this.filterGameList();
        let accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-center1 markets">
                        <section className='login-mar-top100 bg-black'>
                            <div className={`container-fluid casino-content-page ${this.state.operator}`} >
                            { (!!profData && profData.role !== 'DemoClient') && (!!accData && Object.keys(accData).length > 0) ?
                                <>
                                    {this.state.openGame !== true ? <>
                                    <div className="row ">
                                        <div className="col-12">
                                            <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                            </div>
                                        </div>
                                    </div>
                                    {!this.state.loader &&
                                        <div className='row'>
                                            <div className="sportbook-livecasino">
                                                <div className="text-center">
                                                    {<img alt="" src={BASE_IMAGE_PATH + "/casino/banner/wacbanner.jpg"} ></img>}
                                                </div>
                                            </div>
                                            <div className='mt-4 wacfilterbox'>
                                                <div className='casino-nav'>
                                                    <div className='casino-nav__search-container'>
                                                        <div className="casino-nav__search-item casino-nav__search-item--button">
                                                            <input id="txtSearchGame" className="casino-nav__search-input form-control" type="text" placeholder="Search" name='searchGame' value={this.state.searchGame} onChange={(e) => { this.onChange(e) }} />
                                                            <i className="fa fa-search pr-1 wacsearch" aria-hidden="true"></i>
                                                        </div>
                                                        <div className='casino-nav__search-item casino-nav__search-input_menu'>
                                                            <div className='provider-filter'>
                                                                <Multiselect
                                                                    placeholder='Provider'
                                                                    options={this.state.partner} // Options to display in the dropdown
                                                                    selectedValues={this.state.selectedPartner} // Preselected value to persist in dropdown
                                                                    onSelect={(data) => this.handleSelectPartner(data)} // Function will trigger on select event
                                                                    onRemove={(data) => this.handleSelectPartner(data)} // Function will trigger on remove event
                                                                    displayValue="name" // Property name to display in the dropdown options
                                                                    hidePlaceholder={true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='casino-nav__search-item casino-nav__search-input_menu'>
                                                            <div className='provider-filter'>
                                                                <Multiselect
                                                                    placeholder='Type'
                                                                    options={this.state.categories} // Options to display in the dropdown
                                                                    selectedValues={this.state.selectedCategory} // Preselected value to persist in dropdown
                                                                    onSelect={(data) => this.handleSelectCategory(data)} // Function will trigger on select event
                                                                    onRemove={(data) => this.handleSelectCategory(data)} // Function will trigger on remove event
                                                                    displayValue="name" // Property name to display in the dropdown options
                                                                    hidePlaceholder={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.searchGame !== "" &&
                                                <div className='mt-4 wacsearch-result'>

                                                    <div className='waccasino-search-result'>
                                                        <h2 className="waccasino-search-title">Results for "{this.state.searchGame}"</h2>
                                                        <p className="waccasino-search-count"> {gameList.length}</p>
                                                    </div>
                                                </div>
                                            }

                                            <div className=" mt-2 mb-2 featured-game1 wac-min-height wac-width-100">
                                                {
                                                    gameList.length > 0 && gameList.map((game) => (
                                                        <div className='wac-20'>
                                                            <div className="wacmain-box " key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                                <img alt="" src={BASE_IMAGE_PATH + `/casino/img/wac/${game.gameId}.jpg`} className="img-fluid" />
                                                                <div className='slots__bg'>
                                                                    <div className="slots__overlay">
                                                                        <a className="slots__btn">Play</a>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="text-center game-title-main game-title-main-wac">{game.gameName}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            {/* <div className=" mt-2 mb-2 featured-game1  wac-min-height wac-width-100">
                                                <div className='wac-20'>
                                                    <div className="wacmain-box">
                                                        <img alt="" src="https://images.staticcontents.com/ecasino/7888.evp_thegreatwalltreasure.jpg" className="img-fluid" />
                                                        <div className="slots__bg"><div className="slots__overlay"><div className="slots__favorite"></div><a className="slots__btn">Play</a></div></div>
                                                    </div>
                                                    <div className="text-center game-title-main game-title-main-wac">dsdsdsdd</div>
                                                </div>
                                                <div className='wac-20'>
                                                    <div>
                                                        <img alt="" src="https://images.staticcontents.com/ecasino/7888.evp_thegreatwalltreasure.jpg" className="img-fluid" />
                                                    </div>
                                                </div>
                                                <div className='wac-20'>
                                                    <div>
                                                        <img alt="" src="https://images.staticcontents.com/ecasino/7888.evp_thegreatwalltreasure.jpg" className="img-fluid" />
                                                    </div>
                                                </div>
                                                <div className='wac-20'>
                                                    <div>
                                                        <img alt="" src="https://images.staticcontents.com/ecasino/7888.evp_thegreatwalltreasure.jpg" className="img-fluid" />
                                                    </div>
                                                </div>
                                                <div className='wac-20'>
                                                    <div>
                                                        <img alt="" src="https://images.staticcontents.com/ecasino/7888.evp_thegreatwalltreasure.jpg" className="img-fluid" />
                                                    </div>
                                                </div>
                                                <div className='wac-20'>
                                                    <div>
                                                        <img alt="" src="https://images.staticcontents.com/ecasino/7888.evp_thegreatwalltreasure.jpg" className="img-fluid" />
                                                    </div>
                                                </div>
                                            </div> */}

                                        </div>}
                                </> :
                                    <div className="row">
                                        <div onClick={() => { this.setState({ openGame: false, isLoading: false }) }} style={{ position: "absolute", width: "30px", textAlign: "center" }}><i className="fa fa-times popup-cross"></i></div>
                                        <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.link}></iframe>
                                    </div>
                                }  
                                </>
                                :
                                <>
                                    <div className='text-blue mt-3'>
                                        Login with Real ID.
                                    </div>
                                </>
                            }
                            </div>
                        </section>
                    </div>
                    {this.state.showPopup && <>
                        <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-sm modal-dialog-centered encasino">
                                <div className="modal-content">
                                    {/* <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">LIVE CASINO INFO</h5><button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    </div> */}
                                    <div className="modal-body engcasinomodalbgimg">

                                        <button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close text-white ecasinobtnclose" data-dismiss="modal" aria-hidden="true">×</button>
                                        <img alt="" src={"https://images.staticcontents.com/casino/banner/images/new-popup.png"} className="img-fluid" />
                                        <button type="button" className='virtual-close-btn' onClick={() => { this.setState({ showPopup: false }) }} data-dismiss="modal">&nbsp;</button>

                                    </div>
                                    {/* <div className="modal-footer">
                                        <button type="button" onClick={() => { this.setState({ showPopup: false }) }} className="btn btn-danger waves-effect mx-auto" data-dismiss="modal">Continue</button>
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { }}></div>
                        </div>
                    </>}
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WACCasino);